import { Link } from "react-router-dom";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { IconButton } from '@material-ui/core';
export const CustomRouteHeader = (props) => {
    const { pathUrl, createName, prevPathName } = props
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "start", justifyContent: "center" }}>
            <div><IconButton size="small" component={Link} to={pathUrl}>
                <ArrowBackIcon style={{fontSize: 20}} />
            </IconButton> <span className="secondaryColor fontWeightSemiBold">{createName}</span>
            </div>
            <div className="fontWeightMedium" style={{ fontSize: 10, color: "#AAAAAA" }}>
                {prevPathName} / {createName}
            </div>
        </div>
    )
}